module.exports = __webpack_public_path__ + "img/F - 04.37e1d38e.png";